import {
    UserPreferencesProvider,
    useUserPreferences,
} from './UserPreferencesProvider';

export { UserPreferencesProvider };

export default useUserPreferences;
